// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var Belt_Array = require("rescript/lib/js/belt_Array.js");
var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RelayRuntime = require("relay-runtime");

var Types = {};

var fragmentConverter = {};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function makeConnectionId(connectionParentDataId) {
  return RelayRuntime.ConnectionHandler.getConnectionID(connectionParentDataId, "NotificationPreferencesAreasInputV5_result_areas", undefined);
}

function getConnectionNodes(connection) {
  if (connection === undefined) {
    return [];
  }
  var edges = connection.edges;
  if (edges !== undefined) {
    return Belt_Array.keepMap(edges, (function (edge) {
                  if (edge !== undefined) {
                    return edge.node;
                  }
                  
                }));
  } else {
    return [];
  }
}

function areaTypeV5_decode($$enum) {
  if ($$enum === "TOWNSHIP" || $$enum === "STATE" || $$enum === "SCHOOL_DISTRICT" || $$enum === "SCHOOL" || $$enum === "NEIGHBORHOOD" || $$enum === "COUNTY" || $$enum === "CITY" || $$enum === "CENSUS_PLACE" || $$enum === "BLOCK_GROUP" || $$enum === "ZIP_CODE") {
    return $$enum;
  }
  
}

function areaTypeV5_fromString(str) {
  return areaTypeV5_decode(str);
}

var Utils = {
  getConnectionNodes: getConnectionNodes,
  areaTypeV5_decode: areaTypeV5_decode,
  areaTypeV5_fromString: areaTypeV5_fromString
};

var node = {
  "kind": "InlineDataFragment",
  "name": "NotificationPreferencesAreasInputV5_result"
};

exports.Types = Types;
exports.Internal = Internal;
exports.makeConnectionId = makeConnectionId;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
